import Headroom from "../headroom.js";

// ----------------------------------------
// ----------------------------------------
// -------------- Headroom ----------------
// ----------------------------------------
// ----------------------------------------

const myElement = document.querySelector("#header");
const headroom = new Headroom(myElement);

headroom.init();

// ----------------------------------------
// ----------------------------------------
// -------------- Headroom ----------------
// ----------------------------------------
// ----------------------------------------
